module.exports = __webpack_public_path__ + "773898253c55425c56c092f9711f654a.svg";